import { render, staticRenderFns } from "./HomePatient.vue?vue&type=template&id=3ea3519f"
import script from "./HomePatient.vue?vue&type=script&lang=js"
export * from "./HomePatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports